<template>
  <div class="mgl-map-wrapper" style="height: 100%; width: 100%; position: relative;">
    <div ref="mapContainer" class="mgl-map-container" style="height: 100%; width: 100%;" />
    <slot v-if="loaded" />
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl";

export default {
  name: "MglMap",
  props: {
    accessToken: {
      type: String,
      required: true,
    },
    mapStyle: {
      type: [String, Object],
      default: "mapbox://styles/mapbox/streets-v11",
    },
    center: {
      type: Array,
      default: () => [0, 0],
    },
    zoom: {
      type: Number,
      default: 1,
    },
    minZoom: {
      type: Number,
      default: 0,
    },
    maxZoom: {
      type: Number,
      default: 22,
    },
    bearing: {
      type: Number,
      default: 0,
    },
    pitch: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loaded: false,
      map: null,
    };
  },
  provide() {
    const self = this;
    return {
      get map() {
        return self.map;
      },
      get mapComponent() {
        return self;
      },
    };
  },
  mounted() {
    mapboxgl.accessToken = this.accessToken;

    this.map = new mapboxgl.Map({
      container: this.$refs.mapContainer,
      style: this.mapStyle,
      center: this.center,
      zoom: this.zoom,
      minZoom: this.minZoom,
      maxZoom: this.maxZoom,
      bearing: this.bearing,
      pitch: this.pitch,
    });

    this.map.on("load", () => {
      this.loaded = true;
      this.$emit("load", { map: this.map });
    });
  },
  beforeDestroy() {
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
  },
  watch: {
    mapStyle(val) {
      if (this.map) this.map.setStyle(val);
    },
    center(val) {
      if (this.map) this.map.setCenter(val);
    },
    zoom(val) {
      if (this.map) this.map.setZoom(val);
    },
  },
};
</script>
